// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52e6e6ba","732":"6a8679ba","977":"8a44f628"}[chunkId] + ".chunk.js";
};